import {
  match as TMatch,
  RouteProps,
  useLocation,
} from '@jupiter/plugin-runtime/router';
import { useEffect } from 'react';
import { matchRoutes } from './utils';

export function useRouteMatch<P extends {}>(
  cb: (match: TMatch<P>, search: string) => void,
  targetPath: string | string[],
  optionOrExact:
    | Pick<RouteProps, 'strict' | 'sensitive' | 'exact'>
    | boolean = true,
) {
  const { pathname, search } = useLocation();
  useEffect(() => {
    try {
      const match = matchRoutes<P>(
        pathname,
        targetPath,
        typeof optionOrExact === 'boolean'
          ? { exact: optionOrExact }
          : optionOrExact,
      );
      if (match) {
        cb(match, search);
      }
    } catch (e: any) {
      console.error(e);
    }
  }, [pathname]);
}
